"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INBOUND_SPD_MIN_BOX_WEIGHT = exports.INBOUND_SPD_MAX_BOX_WEIGHT = exports.INBOUND_SPD_MIN_BOX_DIM = exports.INBOUND_SPD_MAX_BOX_SHORTEST = exports.INBOUND_SPD_MAX_BOX_MIDDLE = exports.INBOUND_SPD_MAX_BOX_LONGEST = void 0;
exports.INBOUND_SPD_MAX_BOX_LONGEST = 40;
exports.INBOUND_SPD_MAX_BOX_MIDDLE = 30;
exports.INBOUND_SPD_MAX_BOX_SHORTEST = 30;
exports.INBOUND_SPD_MIN_BOX_DIM = 1;
exports.INBOUND_SPD_MAX_BOX_WEIGHT = 50;
exports.INBOUND_SPD_MIN_BOX_WEIGHT = 1;
//# sourceMappingURL=SPDConstants.js.map